import palette from '../palette';
import typography from '../typography';

const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: 4,
    },
  },
  variants: [
    {
      props: { variant: 'outlined' },
      style: {
        borderRadius: 25,
      },
    },
    {
      props: { variant: 'tab' },
      style: {
        '& > span': {
          padding: 0,
        },
        borderRadius: 2,
        height: 20,
        padding: '2px 4px',
        width: 'min-content',
      },
    },
    {
      props: { variant: 'profile' },
      style: {
        backgroundColor: palette.graphic.light,
        borderRadius: 4,
        borderTop: `2px solid ${palette.surface.white}`,
        color: palette.text.secondary,
        marginTop: -8,
        zIndex: 1,
      },
    },
    {
      props: { variant: 'badge' },
      style: {
        ...typography.body1,
        '.MuiChip-label': {
          padding: 0,
          textOverflow: 'unset',
        },
        backgroundColor: palette.graphic.light,
        borderRadius: 4,
        color: palette.text.secondary,
        display: 'flex',
        fontSize: 12,
        fontWeight: 600,
        height: 20,
        padding: 0.5,
        width: 32,
      },
    },
    {
      props: { type: 'green', variant: 'badge' },
      style: {
        backgroundColor: palette.primary.light,
        color: palette.primary.dark,
      },
    },
    {
      props: { type: 'accordion', variant: 'badge' },
      style: {
        '.MuiChip-label': {
          fontWeight: 400,
        },
        backgroundColor: palette.secondary.light,
        color: palette.text.primary,
        width: 25,
      },
    },
    {
      props: { variant: 'selection' },
      style: {
        backgroundColor: 'transparent',
        border: '1px solid',
        borderColor: palette.secondary.main,
        borderRadius: 25,
        color: palette.text.secondary,
      },
    },
    {
      props: { color: 'info' },
      style: {
        backgroundColor: palette.graphic.main,
        color: palette.text.primary,
      },
    },
    {
      props: { color: 'success' },
      style: {
        backgroundColor: palette.secondary.medium,
        color: palette.primary.dark,
      },
    },
    {
      props: { color: 'error' },
      style: {
        backgroundColor: palette.error.dark,
        color: palette.surface.white,
      },
    },
    {
      props: { color: 'datagrid.error' },
      style: {
        backgroundColor: 'red',
        color: 'blue',
      },
    },
    {
      props: { color: '_next.warning' },
      style: {
        backgroundColor: '_next.statusChip.warning.background',
        color: '_next.statusChip.warning.dark',
      },
    },
    {
      props: { color: '_next.error' },
      style: {
        backgroundColor: '_next.statusChip.error.background',
        color: '_next.statusChip.error.main',
      },
    },
    {
      props: { color: '_next.primary' },
      style: {
        backgroundColor: '_next.statusChip.primary.background',
        color: '_next.statusChip.primary.dark',
      },
    },
    {
      props: { variant: 'autocomplete' },
      style: ({ theme }) => ({
        backgroundColor: palette._next.secondary.main,
        borderRadius: '100px',
        color: palette._next.secondary.contrastText,
        fontFamily: 'Overpass',
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        paddingTop: '2.5px',
      }),
    },
  ],
};

export default MuiChip;
